import { request } from "../utils/request.js"

export const wareHouse_addNew = (pojo, args) => request({
    url: 'wareHouse/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const wareHouse_update = (pojo, args) => request({
    url: 'wareHouse/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const wareHouse_findListForSelect = (args) => request({
	url: 'wareHouse/findListForSelect',
	method: 'GET',
	showLoading: true,
	showFailToast: true,
	...args
})

export const wareHouse_findPageForManage = (pojo, args) => request({
    url: 'wareHouse/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const wareHouse_changeFrozenStatus = (id, args) => request({
    url: 'wareHouse/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const wareHouse_findById = (id, args) => request({
    url: 'wareHouse/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

// 分页查询 - 选择页面分页查询 默认按名称正序排列
export const wareHouse_findPageForSelect = (params, args) => request({
    url: 'wareHouse/findPageForSelect',
    method: 'POST',
    params: params,
    showLoading: true,
    showFailToast: true,
    ...args
})

export const wareHouse_deleteById = (id, args) => request({
    url: 'wareHouse/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const wareHouse_setDefault = (id, args) => request({
    url: 'wareHouse/setDefault',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/wareHouse.js